export const SET_AMOUNT = 'SET_AMOUNT';
export const SET_RE_AMOUNT = 'SET_RE_AMOUNT';
export const SET_CITY = 'SET_CITY';
export const SET_STREET = 'SET_STREET';
export const SET_STREET_2 = 'SET_STREET_2';
export const SET_STATELOCALE = 'SET_STATELOCALE';
export const SET_ZIP = 'SET_ZIP';
export const SET_NOTES = 'SET_NOTES';
export const SET_OFFICE = 'SET_OFFICE';
